//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'bmessaging'
let resource_name = 'bmessaging'
let resource_name_plural = 'bmessaging'

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async get_bmid ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}`, {params: params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name} id.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name} id.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async validate_domain ({ commit }, params) {
    try {
      if(process.env.NODE_ENV == "development" && params.callback) {
        params.callback({success:true})
        return
      }
      let res = await Vue.request.get(`${resource}/validate_domain`, {params: params.params || {}})
      if(params.callback) {
        params.callback(res.data)
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error validando dominio de ${resource_name} id.`})
      console.error(e)
    }
  },
  async get_url ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/url`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name} url.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name} url.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
